import React, { useState } from 'react'
import dayjs from 'dayjs'
import DatePicker from './DatePicker'
import ClickAwayHandler from '../../../components/ClickAwayHandler'

const DateSelection = ({
  startDate,
  startDateLabel = 'Outward Date',
  endDate,
  endDateLabel = 'Return Date',
  handleSelectDate,
  isOneWay,
  widgetType,
  onCalendarOpen,
  hasEndDateError,
}) => {
  const [calendarState, setCalendarState] = useState({
    isOpen: false,
    focusDate: 'startDate',
  })
  const [monthsToShow, setMonthsToShow] = useState(
    window.innerWidth > 768 && widgetType !== 'card' ? 2 : 1,
  )
  const closeCalendar = () =>
    setCalendarState({
      ...calendarState,
      isOpen: false,
    })

  const onDateSelect = day => {
    if (calendarState.focusDate === 'startDate') {
      handleSelectDate(calendarState.focusDate, day.format('YYYY-MM-DD'))

      setCalendarState({
        ...calendarState,
        isOpen: !isOneWay,
        focusDate: isOneWay ? 'startDate' : 'endDate',
      })
    } else {
      let key = calendarState.focusDate
      if (day.isBefore(dayjs(startDate), 'days')) {
        key = 'startDate'
      } else {
        setCalendarState({
          ...calendarState,
          isOpen: false,
        })
      }
      handleSelectDate(key, day.format('YYYY-MM-DD'))
    }
  }
  const selectedDates =
    startDate && endDate && !isOneWay
      ? Array.from(
          { length: dayjs(endDate).diff(dayjs(startDate), 'days') + 1 },
          (_, i) => dayjs(startDate).add(i, 'days').format('YYYY-MM-DD'),
        )
      : startDate
      ? [startDate]
      : []

  return (
    <ClickAwayHandler handleClickAway={closeCalendar}>
      <div className="date-input">
        <label>
          <p>{startDateLabel}</p>
        </label>
        <button
          type="button"
          className={` ${
            !startDate ? 'text-sm tracking-wide font-heading' : ''
          }`}
          onClick={() => {
            setMonthsToShow(
              window.innerWidth > 768 && widgetType !== 'card' ? 2 : 1,
            )
            setCalendarState({
              isOpen: true,
              focusDate: 'startDate',
            })
          }}
        >
          {startDate
            ? dayjs(startDate).format('ddd DD MMM YYYY')
            : startDateLabel}
        </button>
      </div>

      <div className={`diagonal-line ${isOneWay ? 'oneway' : ''}`} />

      <div
        className={`date-input ${isOneWay ? 'oneway' : ''} ${
          hasEndDateError ? 'error' : ''
        }`}
      >
        <label>
          <p>{endDateLabel}</p>
        </label>
        <button
          type="button"
          disabled={isOneWay}
          className={`${!endDate ? 'text-sm tracking-wide font-heading' : ''}`}
          onClick={() => {
            setCalendarState({
              isOpen: true,
              focusDate: 'endDate',
            })
          }}
        >
          {endDate ? dayjs(endDate).format('ddd DD MMM YYYY') : endDateLabel}
        </button>
        {hasEndDateError && <p className="end-date-error">Required</p>}
      </div>
      {calendarState.isOpen && (
        <>
          <DatePicker
            handleSelectDate={date => onDateSelect(date)}
            date={startDate}
            endDate={endDate}
            selectedDates={selectedDates}
            isOneWay={isOneWay}
            monthsToShow={monthsToShow}
            onOpen={onCalendarOpen}
          />
        </>
      )}
    </ClickAwayHandler>
  )
}

export default DateSelection
